import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-filtering-list-box', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    padding: '1px',
});

cssRule('.tb-filtering-list-box .tb-data-grid-cell, .tb-filtering-list-box .tb-filtering-list-box-row, .tb-filtering-list-box .tb-data-grid-cell-text, .tb-filtering-list-box .tb-data-grid-row-background', {
    height: '27px',
    lineHeight: '27px',
});

cssRule('.tb-filtering-list-box-textbox', {
    position: 'relative',
});

cssRule('.tb-filtering-list-box-textbox .tb-text-box-border', {
    paddingLeft: '21px',
});

cssRule('.tb-filtering-list-box-textbox .tb-search-button', {
    left: '4px',
});

cssRule('.tb-list-box', {
    position: 'absolute',
    top: '31px',
    right: 0,
    bottom: 0,
    left: 0,
    transform: 'translateZ(0)',
    '-webkit-transform': 'translateZ(0)',
    /* error: '-moz-transform': 'translateZ(0)', */
    '-ms-transform': 'translateZ(0)',
    /* error: '-o-transform': 'translateZ(0)', */
});

cssRule('.tb-list-box strong', {
    fontStyle: 'normal',
    textDecoration: 'underline',
});

cssRule('.tb-list-box .tb-scroll', {
    margin: '0 4px 4px 4px',
});

cssRule('.tb-filtering-list-box-row', {
    height: '37px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

cssRule('.tb-dialog-filtering-list-box-wrapper', {
    position: 'relative',
    height: '300px',
});

cssRule('.tb-dialog-filtering-list-box-wrapper .tb-filtering-list-box', {
    padding: 0,
});

cssRule('.tb-dialog-filtering-list-box-wrapper .tb-filtering-list-box-textbox', {
    padding: '3px 0',
});

cssRule('.tb-dialog-filtering-list-box-wrapper .tb-filtering-list-box-textbox .tb-search-button', {
    left: '1px',
});

cssRule('.tb-dialog-filtering-list-box-wrapper .tb-list-box', {
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
    padding: 0,
    position: 'absolute',
    top: '29px',
    right: 0,
    bottom: 0,
    left: 0,
});

cssRule('.tb-dialog-filtering-list-box-wrapper .tb-list-box .tb-scroll', {
    margin: '3px',
});

